import React from 'react'
import FAQ from './FAQ'
import Navbar from '../NavBar/Navbar'
import Home9 from '../Home/Home9'

const FAQMain = () => {
    return (
        <div>
            <Navbar />
            <FAQ />
            <Home9 />
        </div>
    )
}

export default FAQMain
